export default {
  START_DATE: 'startDate',
  NUM_ACTIVE_PILLS: 'numActivePills',
  NUM_PLACEBO_PILLS: 'numPlaceboPills',
  PILL_TYPE: 'pillType',
}